import React, { Component } from 'react';

import ParkinglocationSelect from './ParkinglocationSelect';

import { Form, Input, Button, Modal } from 'antd';
const FormItem = Form.Item;

class ParkinglocationPlacesForm extends Component {

  state = {
    modalVisible: false
  }

  form = null;

  componentWillReceiveProps(nextProps) {
    this.setState({
      modalVisible: nextProps.modalVisible
    });
  }

  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        values.parkingLocations = [];
        for (let parkingLocationId of values.parkingLocationIds) {
          values.parkingLocations.push({ plID: parkingLocationId });
        }
        delete values.parkingLocationIds;
        this.props.onSuccess(this.props.form, values);
      }
    });
  }

  renderForm() {
    const { getFieldDecorator } = this.props.form;

    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
    };

    const tailFormItemLayout = {
      wrapperCol: {
        xs: {
          span: 24,
          offset: 0,
        },
        sm: {
          span: 16,
          offset: 8,
        },
      },
    };    

    console.log(this.props.initialValues)

    return (
      <Form onSubmit={this.handleSubmit} ref={ref => { this.form = ref }}>
        <FormItem
          {...formItemLayout}
          label="Kód" >
          {getFieldDecorator('code', {
            initialValue: this.props.initialValues && this.props.initialValues.code
              ? this.props.initialValues.code
              : null,
            rules: [{
              type: 'string', message: 'Položka musí obsahovat text!',
            }],
          })(
            <Input />
          )}
        </FormItem>
        <FormItem
          {...formItemLayout}
          label="Název" >
          {getFieldDecorator('name', {
            initialValue: this.props.initialValues && this.props.initialValues.name
              ? this.props.initialValues.name
              : null,
            rules: [{
              type: 'string', message: 'Položka musí obsahovat text!',
            }, {
              required: true, message: 'Vyplňte prosím tuto položku!',
            }],
          })(
            <Input />
          )}
        </FormItem>
        <FormItem
          {...formItemLayout}
          label="Lokality" >
          {getFieldDecorator('parkingLocationIds', {
            initialValue: this.props.initialValues && this.props.initialValues.parkingLocationsIds
              ? this.props.initialValues.parkingLocationsIds
              : [],
            rules: [{
              required: true, message: 'Vyplňte prosím tuto položku!',
            }],
          })(
            <ParkinglocationSelect
              mode="multiple"
              onChange={(value) => { this.props.form.setFieldsValue({ parkingLocationId: value }); }} />
          )}
        </FormItem>
        <FormItem {...tailFormItemLayout}>
          <Button type="primary" htmlType="submit">Uložit</Button>
        </FormItem>
      </Form>
    );
  }

  render() {
    if (this.props.type && this.props.type === 'modal') {
      return (
        <Modal
          width={650}         
          visible={this.state.modalVisible}
          onCancel={() => {
            this.props.onModalCancel(this.props.form);
            this.setState({ modalVisible: false });
          }}
          footer={<p></p>}
          {...this.props}
        >
          {this.renderForm()}
        </Modal>
      )
    } else {
      return this.renderForm();
    }
  }
}

const WrappedParkinglocationForm = Form.create()(ParkinglocationPlacesForm);

export default WrappedParkinglocationForm;


// WEBPACK FOOTER //
// ./src/components/ParkinglocationGroupsForm.js